<template>
  <Bar
    :options="chartOptions"
    :data="chartData"
    :height="$vuetify.breakpoint.lgAndUp ? '60px' : '120px'"
  />
</template>

<script>
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const COLORS = [
  {
    name: "1/10",
    level: "L10",
    code: "#238100",
  },
  {
    name: "1/30",
    level: "L30",
    code: "#FEFF54",
  },
  {
    name: "1/50",
    level: "L50",
    code: "#FF8038",
  },
  {
    name: "1/100",
    level: "L100",
    code: "#ff1300",
  },
  {
    name: "1/150",
    level: "L150",
    code: "#f027ff",
  },
  {
    name: "1/200",
    level: "L200",
    code: "#880088",
  },
  {
    name: "想定最大規模",
    level: "LMAX",
    code: "#000000",
  },
];

export default {
  name: "BarChart",
  components: { Bar },
  props: ["river"],
  data() {
    return {
      chartData: {
        labels: ["7/24 18:00"],
        datasets: [
          {
            data: [],
            backgroundColor: "rgba(243, 99, 132, 0.2)",
            borderColor: "rgba(243, 99, 132, 1)",
            borderWidth: 0.5,
          },
        ],
      },
      chartOptions: {
        animation: false,
        indexAxis: "y",
        responsive: true,
        scales: {
          x: {
            display: true,
            max: 1000,
          },
          y: {
            display: true,
          },
        },
        plugins: {
          title: {
            display: true,
            text: "",
          },
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.formattedValue + "mm";
              },
            },
          },
          annotation: {
            annotations: {},
          },
        },
      },
    };
  },
  created() {
    this.chartData.datasets[0].data = [this.river.real];
    this.chartOptions.scales.x.max =
      parseInt(this.getRiverMax() / 100) * 100 + 100;

    if (this.$vuetify.breakpoint.mdAndDown) {
      this.chartData.labels = [""];
      this.chartOptions.plugins.title.text = [
        `過去${this.river.realTime}時間実績累加雨量 [mm]`,
        this.river.realBaseDate,
      ];
    } else {
      this.chartData.labels = [this.river.realBaseDate];
      this.chartOptions.plugins.title.text = `過去${this.river.realTime}時間実績累加雨量 [mm]`;
    }

    COLORS.forEach((color, index) => {
      this.chartOptions.plugins.annotation.annotations["box" + (index + 1)] = {
        type: "line",
        borderColor: color.code,
        borderWidth: 1.2,
        scaleID: "x",
        value: this.river[color.level],
        label: {
          display: false,
          drawTime: "afterDatasetsDraw",
          content: () => [`${color.name} : ${this.river[color.level]} mm`],
        },
        enter({ element }) {
          element.label.options.display = true;
          return true;
        },
        leave({ element }) {
          element.label.options.display = false;
          return true;
        },
      };
    });
  },
  methods: {
    getRiverMax() {
      if (this.river.LMAX) {
        return this.river.LMAX;
      } else if (this.river.L200) {
        return this.river.L200;
      } else if (this.river.L150) {
        return this.river.L150;
      } else if (this.river.L100) {
        return this.river.L100;
      } else if (this.river.L50) {
        return this.river.L50;
      } else if (this.river.L30) {
        return this.river.L30;
      } else if (this.river.L10) {
        return this.river.L10;
      }
    },
  },
};
</script>
